module.exports = "bundles/25f6c82fc24512ad7326b3d0013353fa.png";


//////////////////
// WEBPACK FOOTER
// ../src/media/pie-charts/pie-chart-80.png
// module id = 135
// module chunks = 0